import { memo } from 'react';

import {
  ProfileDetailsSectionHeader,
  type ProfileDetailsSectionHeaderWithDataProps,
  type ProfileDetailsSectionHeaderWithoutDataProps,
} from '@/features/profile/components/profileDetails/sectionHeader';
import { PROFILE_ICONS } from '@/features/profile/constants/icons';

export type ProfileDetailsVibeHeaderProps =
  | Omit<
      ProfileDetailsSectionHeaderWithDataProps,
      'icon' | 'label' | 'subTitle'
    >
  | Omit<ProfileDetailsSectionHeaderWithoutDataProps, 'icon' | 'label'>;

export const ProfileDetailsVibeHeader = memo(function ProfileDetailsVibeHeader(
  props: ProfileDetailsVibeHeaderProps,
) {
  const VibeIcon = PROFILE_ICONS.vibe;

  return (
    <ProfileDetailsSectionHeader
      {...props}
      label="Vibe"
      icon={<VibeIcon className="size-7" />}
    />
  );
});
